import { render, staticRenderFns } from "./RegistStageOption.vue?vue&type=template&id=2c38d488&scoped=true&"
import script from "./RegistStageOption.vue?vue&type=script&lang=js&"
export * from "./RegistStageOption.vue?vue&type=script&lang=js&"
import style0 from "./RegistStageOption.vue?vue&type=style&index=0&id=2c38d488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38d488",
  null
  
)

export default component.exports